import { Component, EventEmitter, Output } from '@angular/core';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'vw-calendar-sort-toast',
    imports: [SharedModule, NgClass, TranslateModule],
    templateUrl: './calendar-sort-toast.component.html',
    styleUrl: './calendar-sort-toast.component.scss'
})
export class CalendarSortToastComponent extends BaseToastComponent {
  constructor() {
    super();
  }

  @Output() sortChange = new EventEmitter<{ sort: 'name' | 'date', sortDirection: 'asc' | 'desc' }>();

  sort: 'name' | 'date' | undefined = undefined;
  sortDirection: 'asc' | 'desc' | undefined = undefined;

  onSort(sort: 'name' | 'date', sortDirection: 'asc' | 'desc') {
    this.sort = sort;
    this.sortDirection = sortDirection
    this.sortChange.emit({ sort, sortDirection });
    this.onClose();
  }
}
